import { UserEvent } from '@/types/UserEvent';

export const groupActivityByDate = (userEvents: UserEvent[]) => {
  const grouped = userEvents.reduce(
    (acc, userEvent) => {
      const date = userEvent.created_at.split('T')[0];
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(userEvent);
      return acc;
    },
    {} as Record<string, UserEvent[]>,
  );
  return grouped;
};
